import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import PrevNextNavigation from "@/components/PrevNextNavigation";
import QuoteBlock from "@/components/QuotoBlock";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

interface BlogDetailProps {
    data?: any;
    isLoading?: boolean;
}

const BlogDetail: React.FC<BlogDetailProps> = (props) => {

    const { id } = useParams<{ id: string }>();
    const [breadcrumbChild, setBreadcrumbChild] = useState<string>("");


    const quoteProps = {
        stringValue1: "lorem ipsum lorem ipsum lorem ipsum lorem ipsum",
        stringValue2: "test test test",
        stringValue3: "string value 3",
    };
    const isQuoteVisible = Object.values(quoteProps).some(value => value !== null && value !== undefined && value !== "");

    const {
        data: blogDetail,
        isLoading,
        error
    } = useFetchApi({
        url: `/v1/sub-module/677fadabd2c0311ca14f6b76/collection/${id}/detail`,
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false
        }
    })

    useEffect(() => {
        if (blogDetail && blogDetail.title) {
            setBreadcrumbChild(blogDetail.title)
        }
    }, [blogDetail])

    return (
        <>
            <div>
                <BreadCrumb title={breadcrumbChild} parent="Blog" child="" />
                {/* <PrevNextNavigation /> */}

                <section className="ls ms ms_dark section_padding_40">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-10 col-sm-push-1">
                                <article className="vertical-item content-padding with_background with_bottom_border">
                                    <div className="item-media">
                                        <div className="entry-thumbnail">
                                            <img src={blogDetail?.resim} />
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <header className="entry-header">
                                            <span className="small-text big-spacing pull-right">
                                                <time dateTime="2016-08-01T15:05:23+00:00" className="entry-date">
                                                    {blogDetail?.tarih}
                                                </time>
                                            </span>
                                            <div className="categories-links small-text big-spacing pull-left">
                                                {blogDetail?.__meta__tags}
                                            </div>
                                            <div className="clearfix" />
                                            <h1 className="entry-title">
                                                {blogDetail?.title}
                                            </h1>

                                        </header>
                                        {/* .entry-header */}
                                        <div className="entry-content">
                                            <p dangerouslySetInnerHTML={{ __html: blogDetail?.content }}></p>
                                        </div>
                                        {/* .entry-content */}
                                    </div>
                                </article>
                            </div>
                            {/*eof .col-sm-8 (main content)*/}
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default BlogDetail;